import { render, staticRenderFns } from "./iban-view.vue?vue&type=template&id=c7e86b3c&"
import script from "./iban-view.vue?vue&type=script&lang=ts&"
export * from "./iban-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e86b3c')) {
      api.createRecord('c7e86b3c', component.options)
    } else {
      api.reload('c7e86b3c', component.options)
    }
    module.hot.accept("./iban-view.vue?vue&type=template&id=c7e86b3c&", function () {
      api.rerender('c7e86b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iban-view.vue"
export default component.exports